// PrivateRoute.jsx
import { Navigate } from "react-router-dom";
import { isLoggedIn } from "./authHelper";
import { getAuthUser } from "./authHelper";

export const PrivateRoute = ({ children }) => {
  if (!isLoggedIn()) {
    return <Navigate to="/user-login" replace />;
  }
  return children;
};

export const PrivateAdminRoute = ({ children }) => {
  if (!isLoggedIn()) {
    return <Navigate to="/admin/dashboard/login" replace />;
  }
  return children;
};

/* Redirect user after login based on role */

export const RedirectRoute = ({ children }) => {
  const isAuth = isLoggedIn();
  const user = getAuthUser();

  if (isAuth && user?.role === "Patron") {
    return <Navigate to="/patron-home" replace />;
  }

  if (isAuth && user?.role === "MealHost") {
    return <Navigate to="/mealhost-home" replace />;
  }

  if (isAuth && user?.role === "Admin") {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;    
};
